module.exports = __webpack_public_path__ + "static/media/login_logo.7ea55063.png";